//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NavBar from '@/components/NavBar.vue';
import CommonFooter from '@/components/CommonFooter.vue';
import TitleBox from '@/components/TitleBox.vue';
import ScrollTop from '@/components/ScrollTop.vue';
export default {
    components: { NavBar, CommonFooter, TitleBox, ScrollTop },
    beforeRouteEnter(to, from, next) {
        const obj = {
            hotelReservation: 0,
            restaurantReservation: 1,
            specialty: 2,
            food: 3
        };
        const params = to.params;
        if (params.anchor && !params.id) {
            next((vm) => {
                vm.currentItem = obj[params.anchor];
            });
            return;
        }
        /* if (params.anchor && params.id) {
            var propName = '';
            if (params.anchor === 'guide') {
                propName = 'defGuide';
            }
            if (params.anchor === 'video') {
                propName = 'defVideo';
            }
            next(vm => {
                vm[propName] = params.id;
                vm.currentItem = obj[params.anchor];
            });
            return;
        } */
        next((vm) => {
            vm.currentItem = 0;
        });
    },
    beforeRouteUpdate(to, from) {
        const obj = {
            hotelReservation: 0,
            restaurantReservation: 1,
            specialty: 2,
            food: 3
        };
        this.currentItem = obj[to.query.anchor];
    },
    data() {
        return {
            currentItem: 0,
            typeList: [],
            hotelList: [],
            restList: [],
            specialList: [],
            specialFoodList: [],
            show: {
                vr: false,
                hotelDetail: false,
                restDetail: false,
                specialFoodDetail: false
            },
            banner: ''
        };
    },
    watch: {
        i18n() {
            this.scrollTop();
            if (this.currentItem === 0) {
                this.getHotelList();
            } else if (this.currentItem === 1) {
                this.getRestList();
            } else if (this.currentItem === 2) {
                this.getSpecialty();
            } else if (this.currentItem === 3) {
                this.getSpecialFood();
            }
            this.show.hotelDetail = false;
            this.show.restDetail = false;
        },
        currentItem() {
            this.scrollTop();
            this.show.hotelDetail = false;
            this.show.restDetail = false;
            if (this.currentItem === 0) {
                this.getHotelList();
            } else if (this.currentItem === 1) {
                this.getRestList();
            } else if (this.currentItem === 2) {
                this.getSpecialty();
            } else if (this.currentItem === 3) {
                this.getSpecialFood();
            }
        }
    },
    mounted() {
        this.getTypes();
        // this.getSpecialFood();
        this.getHotelList();
    },
    methods: {
        getTypes() {
            this.axios({
                method: 'post',
                url: '/articleCategory/list',
                data: {
                    pid: 4
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.typeList = res.data;
                    console.log('typeList', this.typeList);
                }
            });
        },
        getHotelList() {
            this.axios({
                method: 'post',
                url: '/article/listPage',
                data: {
                    categoryId: '46',
                    pageNum: 1,
                    pageSize: 100,
                    language: this.i18n
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.hotelList = res.data.data;
                }
            });
        },
        getHotelDetail(id) {
            this.scrollTop('auto');
            this.axios({
                method: 'post',
                url: '/article/detail',
                data: {
                    id
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.hotelDetail = res.data;
                    this.show.hotelDetail = true;
                }
            });
        },
        getRestList() {
            this.axios({
                method: 'post',
                url: '/article/listPage',
                data: {
                    categoryId: '47',
                    pageNum: 1,
                    pageSize: 100,
                    language: this.i18n
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.restList = res.data.data;
                }
            });
        },
        getRestDetail(id) {
            this.scrollTop('auto');
            this.axios({
                method: 'post',
                url: '/article/detail',
                data: {
                    id
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.restDetail = res.data;
                    this.show.restDetail = true;
                }
            });
        },
        getSpecialty() {
            this.axios({
                method: 'post',
                url: '/article/listPage',
                data: {
                    categoryId: '48',
                    pageNum: 1,
                    pageSize: 100,
                    language: this.i18n
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.specialList = res.data.data;
                }
            });
        },
        appoint(data) {
            window.open(data.url, 'blank');
        },
        getSpecialFood() {
            this.axios({
                method: 'post',
                url: '/article/listPage',
                data: {
                    categoryId: '49',
                    pageNum: 1,
                    pageSize: 100,
                    language: this.i18n
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.specialFoodList = res.data.data;
                    console.log('specialFoodList', this.specialFoodList);
                }
            });
            // this.axios({
            //     method: 'post',
            //     url: '/articleCategory/detail',
            //     data: {
            //         id: '49'
            //     }
            // }).then((res) => {
            //     if (res.code === 0) {
            //         this.specialFood = res.data.content;
            //     }
            // });
        },
        getSpecialFoodDetail(id) {
            this.scrollTop('auto');
            this.axios({
                method: 'post',
                url: '/article/detail',
                data: {
                    id
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.specialFoodDetail = res.data;
                    this.show.specialFoodDetail = true;
                }
            });
        }
    }
};
